import script from "./DashBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__